import Choose from './Choose';
import Home from './Home';
import Service from '../Service/Service';

function HomeTree() {

    return(
        <div>
        
        <Home></Home>
        <Service></Service>
        <Choose></Choose>
       
        </div>
    )
}
export default HomeTree;
